import React from "react";
import { Card } from "react-bootstrap";
import styled from "styled-components";

import { NoRecordCard } from "../../../common/components";
import { Table } from "../../../common/components/core";
import { ResponseWithPagination, BankAccount } from "../../../types/common";
import { SuperAdminRole } from "../../../types/superadmin";
import BankStatusBox from "./BankStatusBox";


type AccountListProps = {
    accountType: SuperAdminRole;
    accountsPage: ResponseWithPagination<BankAccount[]>;
    onClick: (id: number) => void;
    nextPage: () => void;
    prevPage: () => void;
    toPage: (page: number) => void;
};

const AccountList = ({
    accountType,
    // accounts,
    accountsPage,
    onClick,
    nextPage,
    prevPage,
    toPage,
}: AccountListProps): JSX.Element => {
    return accountsPage.content.length === 0 ? (
        <NoRecordCard />
    ) : (
        <Card className="mt-4 border-0">
            <Card.Body className="px-0 py-0">
                <table className={'custom-table'}>
                    <thead>
                        <tr>
                            <Table.HeaderCell width={280}>
                                {`${accountType} Bank Account Holder Name`}
                            </Table.HeaderCell>
                            <Table.HeaderCell width={200}>
                                {`${accountType} Bank Account Number`}
                            </Table.HeaderCell>
                            <Table.HeaderCell width={200}>
                                SWIFT Address
                            </Table.HeaderCell>
                            <Table.HeaderCell width={200}>
                                Payment Currency
                            </Table.HeaderCell>
                            <Table.HeaderCell width={200}>
                                Profile Name
                            </Table.HeaderCell>
                            <Table.HeaderCell width={200}>
                                Status
                            </Table.HeaderCell>
                        </tr>
                    </thead>
                    <tbody>
                        {accountsPage.content.map((account) => (
                            <Table.BodyRow
                                key={account.id}
                                onClick={() =>
                                    account.id && onClick(account.id)
                                }
                                onKeyUp={(event:KeyboardEvent) =>
                                    {(event.keyCode === 13 || event.keyCode === 32) &&
                                        account.id && onClick(account.id);
                                    }
                                }
                            >
                                <StyledTd>{account.bankAccountHolderName}</StyledTd>
                                <StyledTd>{account.bankAccountNumber}</StyledTd>
                                <StyledTd>{account.swiftAddress}</StyledTd>
                                <StyledTd>{account.currency}</StyledTd>
                                <StyledTd>{account.userProfile.name}</StyledTd>
                                <StyledTd>
                                    <BankStatusBox status={account.status} />
                                </StyledTd>
                            </Table.BodyRow>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={6}>
                                <Table.Pagination
                                     backArrowOnClick={prevPage}
                                     nextArrowOnClick={nextPage}
                                     backArrowDisabled={accountsPage.first}
                                     nextArrowDisabled={accountsPage.last}
                                     totalPage={accountsPage.totalPages}
                                     currentPage={accountsPage.number + 1}
                                     onPageNumberChange={(page) => toPage(page - 1)}
                                />
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </Card.Body>
        </Card>
    );
};

const StyledTd = styled.td`
    vertical-align: top;
`;

export default AccountList;
